<template>
  <div
    class="social-marketing-card-container"
    :class="`social-marketing-card-container--${size}`"
  >
    <span
      class="download-button"
      @click="$emit('download')"
      v-if="$listeners.download"
    >
      <HMSpinner class="download-spinner" v-if="inProgress" />
      <font-awesome-icon v-else :icon="['far', 'file-download']" />
    </span>
    <div class="social-marketing-card-container_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'SocialMarketingCardContainer',
  props: {
    size: {
      type: String,
      default: 'square',
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.social-marketing-card-container {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background-position: center center;
  background-repeat: no-repeat;

  user-select: none;

  &--square {
    height: 1080px;
    width: 1080px;
  }

  &--story {
    height: 1920px;
    width: 1080px;
  }
}

.social-marketing-card-container .download-button {
  display: none;
}

.download-spinner {
  width: 13px * $social-marketing-card-factor;
  height: 13px * $social-marketing-card-factor;
}

@include media-breakpoint-up(md) {
  .social-marketing-card-container:hover .download-button {
    position: absolute;
    top: calc(15px * #{$social-marketing-card-factor});
    right: calc(30px * #{$social-marketing-card-factor});
    width: 50px * $social-marketing-card-factor;
    height: 50px * $social-marketing-card-factor;
    border-radius: 6px * $social-marketing-card-factor;
    background-color: $lightest-gray;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem * $social-marketing-card-factor;
  }
}

.social-marketing-card-container_content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
